<template>
	<div>
		<div v-if="shipment.shipment_status!=$keys.DELIVERED">
		<v-menu  offset-y>
			<template v-slot:activator="{ on }">
				<v-btn text  rounded small v-on="on" class="px-2 btn-whithout-hover" :ripple="false">
					<span  v-on="on"  :class="getClassSatus(shipment.shipment_status)">{{shipment.shipment_status}}
						<v-icon>mdi-menu-down</v-icon>
					</span>
				</v-btn>
			</template>
			<v-list class="px-0">
				<div v-for="(status, i) in status_list" :key="i">
					<v-list-item class="cursor-pointer px-1 py-0 my-1" :class="(i+1)==status_list.length?'mb-0':i" style="min-height:25px" @click="confirmChangeShipmentstatus(status)"
					v-if="shipment.shipment_status!=status">
					<span  :class="getClassSatus(status)">{{status}}</span>
				</v-list-item>
			</div>
		</v-list>
	</v-menu>
</div>
<div v-else>
	<span  :class="getClassSatus(shipment.shipment_status)">{{shipment.shipment_status}}	</span>
</div>
	<common-confirmation-dialog :dialog="dialog" :YesClickHanler="ChangeShipmentStaus" />
</div>
</template>
<script>
export default{
	props:['shipment'],
	components: {
		CommonConfirmationDialog :()=>import('@/components/common-components/CommonConfirmationDialog.vue'),

	},
	data(){
		return{
			status_list:["Confirmation Pending","Confirmed","Dropped at Warehouse", "Dropped at Warehouse Return","On Hold", ],
			dialog:{
				id:"",
				name:"",
				flag:false,
				status:"",
				msg:"",
				note:""
			}
		}
	},
	methods:{
		/* Open confimation dialog for cancelation */ 
		confirmChangeShipmentstatus(status){
			this.dialog.id=this.shipment.shipment_id
			this.dialog.name=this.shipment.shipment_id
			this.dialog.status=status
			this.dialog.msg="want to change shipment status to "+status
			if(status==this.$keys.DROPPED_AT_WAREHOUSE_RETURN)
				this.dialog.note=this.$messages.NOTE_FOR_MANUAL_STATUS_CHANGE
			else
				this.dialog.note=""
			this.dialog.flag=true

		},
		/* cancelt shipment Api call*/ 
		ChangeShipmentStaus(){
			const self=this;
			var	form = new FormData();
			form.append("shipment_id",this.shipment.shipment_id);
			form.append("shipment_status",this.dialog.status);
			const successHandler = (response) => {
				self.dialog.flag=false
				self.dialog.btn_loading=false
				self.dialog.shipment_id=""
				self.dialog.flag=false
				self.shipment.shipment_status=this.dialog.status
				// self.$emit("refresh-data")
				// self.getShipmentList()
			};
			const finallyHandler = () => {
			};
			this.request_POST(self,self.$urls.CHANGE_SHIPMENT_STATUS,form,successHandler,null,null,finallyHandler)	
		}
	}


}
</script>